import React from 'react';
import { Link } from 'react-router-dom';
import bgImg from '../Images/CCA-Abstract-Shapes-02.jpg';

function Breadcrumb({ title, pageName }) {
  return (
    <div className="breadcrumb-banner" style={{ backgroundImage: `linear-gradient(135deg, rgba(17, 88, 134, 0.9) 0%, rgba(13, 55, 83, 0.96) 100%), url(${bgImg})` }}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-8 text-center text-lg-start">
            <h1 className="breadcrumb-title">{title}</h1>
            <nav className="breadcrumb-nav">
              <Link to="/">Home</Link>
              <span className="separator">/</span>
              <span className="current-page">{pageName || title}</span>
            </nav>
          </div>
        </div>
      </div>
      <style dangerouslySetInnerHTML={{
        __html: `
        .breadcrumb-banner {
          position: relative;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          padding: 230px 0;
          color: #fff;
          overflow: hidden;
          margin-bottom: 40px;
          border-bottom: 4px solid #89c764;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        }
        
        .breadcrumb-banner::before {
          content: "";
          position: absolute;
          width: 350px;
          height: 350px;
          background: rgba(137, 199, 100, 0.12); /* brand green accent */
          border-radius: 50%;
          right: -50px;
          top: -50px;
          filter: blur(90px);
          pointer-events: none;
        }

        .breadcrumb-banner::after {
          content: "";
          position: absolute;
          width: 250px;
          height: 250px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 50%;
          left: -50px;
          bottom: -80px;
          filter: blur(70px);
          pointer-events: none;
        }

        .breadcrumb-title {
          font-size: 38px;
          font-weight: 800;
          margin-bottom: 12px;
          font-family: 'Poppins', sans-serif;
          letter-spacing: -0.5px;
          text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
        }

        .breadcrumb-nav {
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: 'Poppins', sans-serif;
          font-size: 15px;
          font-weight: 500;
          text-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
        }

        @media (min-width: 768px) {
          .breadcrumb-nav {
            justify-content: flex-start;
          }
        }

        .breadcrumb-nav a {
          color: rgba(255, 255, 255, 0.8);
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .breadcrumb-nav a:hover {
          color: #89c764;
        }

        .breadcrumb-nav .separator {
          margin: 0 10px;
          color: rgba(255, 255, 255, 0.4);
        }

        .breadcrumb-nav .current-page {
          color: #89c764;
          font-weight: 600;
        }
      `}} />
    </div>
  );
}

export default Breadcrumb;
